export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/index.worker.d32ec523.worker.js");
}
